// assets
import {
    IconUserPlus,
    IconUser,
    IconUsers,
    IconUserSearch,
    IconSettings,
    IconPlus,
    IconEdit,
    IconBuilding,
    IconDeviceAnalytics
} from '@tabler/icons';

// constant
const icons = {
    IconUser: IconUser,
    IconUsers: IconUsers,
    IconUserSearch: IconUserSearch,
    IconBuilding: IconBuilding,
    IconUserPlus: IconUserPlus,
    IconUserSearch: IconUserSearch,
    IconSettings: IconSettings,
    IconPlus: IconPlus,
    IconEdit: IconEdit,
    IconDeviceAnalytics
};

//-----------------------|| DASHBOARD MENU ITEMS ||-----------------------//

export const dashboard = {
    id: 'settings',
    title: 'Sistema',
    type: 'group',
    children: [
        {
            id: 'administracao',
            title: 'Central de Administração',
            type: 'item',
            url: '/adm/config/',
            icon: icons['IconSettings'],
            breadcrumbs: false
        },
        {
            id: 'settings-users',
            title: 'Configurações',
            type: 'item',
            url: '/dashboard/config/index/',
            icon: icons['IconSettings'],
            breadcrumbs: false
        }
        // ,{
        //     id: 'settings-customs',
        //     title: 'Customização',
        //     type: 'item',
        //     url: '/dashboard/config/custom/',
        //     icon: icons['IconSettings'],
        //     breadcrumbs: false
        // }
    ]
};
